export const Tools = {
    // Комплексный анализ конкурента
    COMPETITORS: 1,
    // Аналитика в поиске
    SEO: 2,
    // Аналитика по ссылкам
    LINKS: 3,
    // Семантическое ядро
    SEMANTIC: 4,
    // Аналитика по рекламе
    ADS: 5,
    // Аналитика по Дзену (удалена)
    DZEN: 6,
    // Прочие задачи
    OTHER: 7,
    // Аналитика по нейросетям
    AI: 8,
}
